// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface DropShipModalState {
    isOpen: boolean;
}

const initialState: DropShipModalState = {
    isOpen: false,
};

const reducer = {
    "xDropShipModal/CompleteSetIsOpen": (draft: Draft<DropShipModalState>, action: DropShipModalState) => {
        draft.isOpen = action.isOpen;
    },
};

const xDropShipModal = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xDropShipModal = xDropShipModal;

export type xDropShipModalState = {
    xDropShipModal: DropShipModalState;
} & ApplicationState;

type DropShipReducer = {
    dropShipModal: typeof xDropShipModal;
};

export type DropShipDataActions = Parameters<DropShipReducer[keyof DropShipReducer]>[1] | AnyAction;
